"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var ga_sidecar_1 = require("@engine/ga-sidecar");
var settings_sidecar_1 = require("@engine/settings-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var uiFps_sidecar_1 = require("@ui/uiFps-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
// import { crokinoleDefs } from '@crokinole/main/crokinoleDefs-sidecar'
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var rogueGlyphs_sidecar_1 = require("@dive/fonts/rogueGlyphs-sidecar");
var perf2_sidecar_1 = require("@engine/perf2-sidecar");
var minigolfSounds_sidecar_1 = require("../sound/minigolfSounds-sidecar");
var minigolfLayers_sidecar_1 = require("./minigolfLayers-sidecar");
var minigolfMainGameGenerator_sidecar_1 = require("../simulation/minigolfMainGameGenerator-sidecar");
var minigolfKeyboard_sidecar_1 = require("../input/minigolfKeyboard-sidecar");
function create() {
    ga_sidecar_1.ga.init('voyage');
    perf2_sidecar_1.perf2.setEnabled(diveDebug_sidecar_1.diveDebug.debug_perf2Enabled);
    spritesUtil_sidecar_1.spritesUtil.setDefaultScale(2);
    settings_sidecar_1.settings.create('minigolf:settings', 1);
    // TODO: restore these
    // crokinoleTestParams.loadTestMode()
    // voyageMessages.registerAll()
    var soundsJson = common_sidecar_1.common.getPhaserScene().cache.json.get('audioSprite2');
    minigolfSounds_sidecar_1.minigolfSounds.load(soundsJson, '/assets/music');
    minigolfLayers_sidecar_1.minigolfLayers.create();
    rogueGlyphs_sidecar_1.rogueGlyphs.setDefaultLayer(minigolfLayers_sidecar_1.minigolfLayers.getLayers().ui1);
    uiFps_sidecar_1.uiFps.create(minigolfLayers_sidecar_1.minigolfLayers.getLayers().uiGame);
    uiFps_sidecar_1.uiFps.setOpen(true);
    clickEater_sidecar_1.clickEater.create();
    minigolfKeyboard_sidecar_1.minigolfKeyboard.createAndInstall();
    minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.start();
    // TODO: restore these
    // crokinoleKeyboard.create()
    // crokinoleWebsockets.create()
    // crokinoleGameManager.goLoading()
    // crokinoleGamepadCursors.createAll()
}
exports.create = create;
